<template>
  <div class="plans row d-flex">
    <div class="flex sm12 xs12">
      <va-card :title="$t('planUpdate.cards.update')">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(onSubmit)">
            <div class="row">
              <div class="flex md12">
                <ValidationProvider rules="required" name="Duração" v-slot="{ errors }">
                  <va-input
                    v-model="plan.name"
                    :label="$t('planAdd.forms.nameLabel')"
                    :placeholder="$t('planAdd.forms.namePlaceholder')"
                    :success="errors.length == 0 && plan.name.length > 0"
                    :error="errors.length > 0"
                    :error-messages="errors"
                  />
                </ValidationProvider>
                <ValidationProvider rules="required" name="Duração" v-slot="{ errors }">
                  <va-input
                    v-model="montante"
                    :label="$t('planAdd.forms.amountLabel')"
                    :placeholder="$t('planAdd.forms.amountPlaceholder')"
                    :success="errors.length == 0 && montante > 0"
                    :error="errors.length > 0"
                    :error-messages="errors"
                  />
                </ValidationProvider>
                <ValidationProvider rules="required|numeric" name="Duração" v-slot="{ errors }">
                  <va-input
                    v-model="duracao"
                    type="number"
                    :label="$t('planAdd.forms.durationLabel')"
                    :placeholder="$t('planAdd.forms.durationPlaceholder')"
                    :success="errors.length == 0 && duracao > 0"
                    :error="errors.length > 0"
                    :error-messages="errors"
                  />
                </ValidationProvider>
                <div class="d-flex mt-3">
                  <va-button
                    type="submit"
                    :disabled="buttonSubmitDisabled"
                    color="success"
                    class="my-0">
                    {{ textSubmit }}
                  </va-button>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </va-card>
    </div>
    <TablePlanItems :planId="planId"></TablePlanItems>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import TablePlanItems from './components/TablePlanItems'
export default {
  name: 'plans',
  props: {
    planId: {
      required: true,
    },
  },
  components: {
    TablePlanItems,
  },
  methods: {
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      const { name, amount, duration } = this.plan
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!, $name: String, $duration: Int, $amount: numeric) {
              update_plan_by_pk(pk_columns: {id: $id}, _set: {amount: $amount, name: $name, duration: $duration}) {
                id
                name
                amount
                duration
              }
            }
          `,
          variables: {
            name,
            amount,
            duration,
            id: this.planId,
          },
        })
        .then(data => {
          this.buttonSubmitDisabled = false
          this.textSubmit = this.$t('forms.submit')
          this.showToast(
            this.$t('toasts.successUpdate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.buttonSubmitDisabled = false
          this.textSubmit = this.$t('forms.submit')
          this.showToast(
            this.$t('toasts.errorUpdate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
  data () {
    return {
      plan: {
        name: '',
        amount: 0,
        duration: 0,
      },
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  apollo: {
    plan: {
      query: gql`
      query MyQuery($id: Int!) {
        plan: plan_by_pk(id: $id) {
          name
          duration
          amount
        }
      }
      `,
      variables () {
        return {
          id: this.planId,
        }
      },
    },
  },
  computed: {
    duracao: {
      get () {
        return this.plan.duration
      },
      set (value) {
        if (value >= 0 && value <= 365) {
          this.plan.duration = value
        }
      },
    },
    montante: {
      get () {
        return this.plan.amount
      },
      set (value) {
        if (value >= 0) {
          this.plan.amount = value
        }
      },
    },
  },
}
</script>

<style lang="scss">
</style>
